module.exports = {"audiences":["allMembers"],"experimentVersion":"v2","experimentAllocation":0.5,"defaultWeight":1,"defaults":{"showBanner":false},"autoTrack":true,"variations":[{"name":"showBanner","weight":1,"values":{"showBanner":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/notifyOverdueTeams.json
// module id = OxEh
// module chunks = 1